import { B2bCompanyDocumentDetails } from '@Common/types/bo/b2b/companies';

import { documentsTranslations as documentsTranslationsEn } from '@I18n/en/documents';

export const documentsTranslations = {
  fields: {
    id: 'Document ID',
    document_url: 'URL',
    document_name: 'Nom',
    document_comment: 'Commentaire',
    type: 'Type',
    task_id: 'ID Tâche',
    co_sepa_mandate_id: 'ID mandat SEPA',
    is_archived: 'Archivé',
    created_at: 'Créé le',
    updated_at: 'Mis à jour le',
    is_generated: 'Généré',
    source: 'Source',
    company_id: 'ID Entreprise',
    b2b_campaign_id: 'ID Opération',
    savings_funds_request_id: 'ID Appel de fonds',
  } satisfies Record<keyof B2bCompanyDocumentDetails, string>,
} satisfies typeof documentsTranslationsEn;
